import React, { useEffect, useRef } from "react";

/**
 * HeroVideo, looping candlelit aromatherapy background video.
 * Muted, inline, lazy metadata preload with an instant poster frame.
 * Pauses automatically for users who prefer reduced motion.
 */
export const HeroVideo = () => {
  const ref = useRef(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      v.pause();
      return;
    }
    // Ensure autoplay actually starts (some browsers defer it)
    const tryPlay = () => v.play().catch(() => {});
    tryPlay();
    v.addEventListener("canplay", tryPlay, { once: true });
    const onInteract = () => {
      tryPlay();
      window.removeEventListener("pointerdown", onInteract);
    };
    window.addEventListener("pointerdown", onInteract);
    return () => {
      v.removeEventListener("canplay", tryPlay);
      window.removeEventListener("pointerdown", onInteract);
    };
  }, []);

  return (
    <video
      ref={ref}
      className="absolute inset-0 h-full w-full object-cover"
      poster="/videos/hero-candles-poster.jpg"
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      aria-hidden="true"
      data-testid="hero-background-video"
    >
      <source src="/videos/hero-candles.webm" type="video/webm" />
      <source src="/videos/hero-candles.mp4" type="video/mp4" />
    </video>
  );
};
